import { styled } from "styled-components";

export const ToggleButton = styled.input`
  -webkit-appearance: none;
  outline: none;
  background: var(--grey1);
  width: 50px;
  height: 28px;
  border-radius: 50px;
  border: none;
  padding: 0;
  cursor: pointer;
  position: relative;

  &::before {
    content: "";
    width: 20px;
    height: 20px;
    border-radius: 50%;
    background: var(--light);
    position: absolute;
    top: 50%;
    left: 3px;
    transform: translateY(-50%);
    transition: 0.15s;
  }

  &:checked {
    background: var(--purple2);

    &::before {
      left: 27px;
      background: var(--ice);
    }
  }
`;

export const ToggleLabel = styled.label`
  cursor: pointer;
  margin-bottom: 0;
  margin-left: 0.5rem;
`;
